/** A map of selectors used in the Extendo menu. */
export const selectors = {
    activeTab: ".exn-active-tab",
    menuFeature: ".rt-menu-feature",
    menuOpen: ".exn-open",
    mobileButton: ".extendomenu .exn-widget-top-level-mobile-toggle",
    panel: ".exn-panel",
    tabbedContentDesktop: ".exn-desktop",
    tabContent: ".exn-widget-tab-content",
    tabContentContainer: ".exn-widget-tab-contents",
    tabLinks: ".exn-widget-tab-anchor[data-tabid^='tab-']",
};
/**
 * Removes the leading period from a class selector.
 *
 * @param selector The key in the selector lookup to match.
 * @returns The class name without the leading period.
 */
export function getRawClassName(selector) {
    return selectors[selector].substring(1);
}
/**
 * Returns an array of elements matching the selector.
 *
 * @template T The type of element to return.
 * @param selector The key in the selector lookup to match.
 * @param parent The parent element to search within. If not provided, the
 *   document is used.
 * @returns An array of elements matching the selector.
 */
export function selectorToArray(selector, parent) {
    const element = parent || document;
    return Array.from(element.querySelectorAll(selectors[selector]));
}
